// Run / bhav shown after the runner in a sports bet row ("… / 100" like the
// player side). Used by the game-details My Bets card and ViewMoreBetsModal.
// On fancy1 (odds yes/no lines) `size` is the max stake (100000+), not a bhav,
// and the reference shows nothing there (user 2026-10-22).
export function betRun(bet) {
  const r = bet.run ?? bet.line ?? bet.fancy_run
  if (r != null) return r
  const fancy1 = [bet.market_type, bet.gtype].some((v) => String(v || '').toLowerCase() === 'fancy1')
  return !fancy1 && Number(bet.size) > 0 ? bet.size : null
}

// Runner text for a bet row: "<selection> / <run>", except khado, which the
// player site prints as "<selection>-<band width>" (band = fancy_name, a bare
// number), and oddeven, "<selection> - ODD|EVEN" (user 2026-10-24).
export function betNation(bet) {
  const selection = bet.selection_name || bet.selection || '-'
  const khado = [bet.market_type, bet.gtype].some((v) => String(v || '').toLowerCase() === 'khado')
  const band = String(bet.fancy_name ?? '').trim()
  if (khado && /^\d+(\.\d+)?$/.test(band)) return `${selection}-${band}`
  // oddeven: "<selection> - ODD" / "- EVEN" — yes = Odd, no = Even (settlementv2)
  if ([bet.market_type, bet.gtype].some((v) => String(v || '').toLowerCase() === 'oddeven')) {
    const even = ['no', 'lay'].includes(String(bet.bet_type || bet.type || '').toLowerCase())
    return `${selection} - ${even ? 'EVEN' : 'ODD'}`
  }
  const run = betRun(bet)
  return run != null && run !== '' ? `${selection} / ${run}` : selection
}
